import React from "react"

import { useTranslation } from "react-i18next"

import { Box, Grid, Skeleton } from "@mui/material"
import { Tooltip, Typography } from "@synapse-analytics/synapse-ui"
import moment from "moment"

import { formatDistance } from "../../utils/genericHelpers"
import { GraphHeader } from "../graphs/GraphHeader"

type Props = {
  date?: Date
  cardHeight: number
  isLoading: boolean
}

export function KonanLastFeedbackCard(props: Readonly<Props>): React.ReactElement {
  const { date, cardHeight, isLoading } = props

  const { t } = useTranslation("cards", {
    keyPrefix: "lastFeedbackCard",
  })

  return (
    <div className={"charts-paper"}>
      <GraphHeader title={t("title")} tooltipText={t("tooltip")} padding="1rem" />

      <Box style={{ height: cardHeight, padding: "4px 16px 8px 16px" }}>
        {!date && !isLoading ? (
          // empty state
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            item
            xs={12}
            className={"full-height"}
          >
            <Typography variant="p" variantColor={2}>
              {t("empty")}
            </Typography>
          </Grid>
        ) : isLoading ? (
          // loading state
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            className={"full-height"}
          >
            <Skeleton animation="wave" width="50%" height="10%" />
          </Grid>
        ) : (
          <Grid container direction="column" justifyContent="center" alignItems="center" style={{ height: cardHeight }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" marginTop={1}>
              <Tooltip title={date && moment(date).format("DD/MM/YYYY, h:mm A")} placement="top">
                <Typography variant="h1-bold">{date && formatDistance(date)}</Typography>
              </Tooltip>
            </Grid>
          </Grid>
        )}
      </Box>
    </div>
  )
}
